var _path, _path2, _path3, _path4, _rect, _rect2, _g, _rect3, _path5, _rect4, _path6, _path7, _path8, _rect5, _g2, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse2, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse3, _path24, _path25, _path26, _path27, _path28, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 615,
    viewBox: "0 0 755 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.795 188.042H255.403C255.725 186.606 255.901 185.113 255.901 183.577C255.901 172.566 247.158 163.639 236.372 163.639C231.814 163.639 227.624 165.238 224.3 167.912C221.702 156.581 211.744 148.142 199.854 148.142C185.989 148.142 174.748 159.619 174.748 173.778C174.748 179.057 176.312 183.964 178.991 188.042H181.896H251.795Z",
    fill: "url(#paint0_linear_7042_25715)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.033 87.7387C616.033 77.8618 608.042 69.855 598.185 69.855C594.566 69.855 591.199 70.9395 588.387 72.7945C583.843 60.5517 572.078 51.8275 558.278 51.8275C545.247 51.8275 534.039 59.6074 529.002 70.7797C526.951 70.1819 524.783 69.855 522.54 69.855C512.46 69.855 503.892 76.3206 500.728 85.3381C498.696 83.1944 495.832 81.8513 492.65 81.8513C486.491 81.8513 481.5 86.8541 481.5 93.0236H615.239C615.754 91.3535 616.033 89.5788 616.033 87.7387Z",
    fill: "url(#paint1_linear_7042_25715)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.311 534.387C364.311 529.513 368.262 525.563 373.135 525.563H496.667C501.54 525.563 505.491 529.513 505.491 534.387H364.311Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.254 490.269H434.901V525.534C414.979 525.599 417.254 525.534 399.606 525.534C411.371 515.226 417.254 503.471 417.254 490.269ZM452.549 490.269C452.549 503.471 458.431 515.226 470.196 525.534C452.549 525.534 454.823 525.599 434.901 525.534V490.269H452.549Z",
    fill: "#4D4D4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 214.308,
    y: 194.682,
    width: 441.186,
    height: 295.587,
    rx: 3.44004,
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7042_25715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 194,
    width: 442,
    height: 297
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 214.308,
    y: 194.682,
    width: 441.186,
    height: 295.587,
    rx: 3.44004,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7042_25715)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.308 199.842C214.308 196.992 216.619 194.682 219.468 194.682H650.334C653.184 194.682 655.494 196.992 655.494 199.842V211.581C655.494 214.431 653.184 216.741 650.334 216.741H219.468C216.619 216.741 214.308 214.431 214.308 211.581V199.842Z",
    fill: "#333333"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.308,
    y: 216.741,
    width: 441.186,
    height: 251.469,
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.891 231.663C269.891 228.338 272.587 225.643 275.911 225.643H374.271C377.595 225.643 380.291 228.338 380.291 231.663V260.903C380.291 264.228 377.595 266.923 374.271 266.923H275.911C272.587 266.923 269.891 264.228 269.891 260.903V231.663ZM234.949 225.643C231.624 225.643 228.929 228.338 228.929 231.663V278.963C228.929 282.288 231.624 284.983 234.949 284.983H257.377C260.702 284.983 263.397 282.288 263.397 278.963V231.663C263.397 228.338 260.702 225.643 257.377 225.643H234.949ZM234.949 389.905C231.624 389.905 228.929 392.6 228.929 395.925V453.545C228.929 456.87 231.624 459.566 234.949 459.566H257.616C260.941 459.566 263.636 456.87 263.636 453.545V395.925C263.636 392.6 260.941 389.905 257.616 389.905H234.949ZM275.911 273.803C272.587 273.803 269.891 276.498 269.891 279.823V309.064C269.891 312.388 272.587 315.084 275.911 315.084H374.271C377.595 315.084 380.291 312.388 380.291 309.064V279.823C380.291 276.498 377.595 273.803 374.271 273.803H275.911ZM269.891 327.984C269.891 324.659 272.587 321.964 275.911 321.964H374.271C377.595 321.964 380.291 324.659 380.291 327.984V357.224C380.291 360.549 377.595 363.244 374.271 363.244H275.911C272.587 363.244 269.891 360.549 269.891 357.224V327.984ZM275.911 370.124C272.587 370.124 269.891 372.82 269.891 376.144V405.385C269.891 408.71 272.587 411.405 275.911 411.405H374.271C377.595 411.405 380.291 408.71 380.291 405.385V376.144C380.291 372.82 377.595 370.124 374.271 370.124H275.911ZM269.891 424.305C269.891 420.98 272.587 418.285 275.911 418.285H374.271C377.595 418.285 380.291 420.98 380.291 424.305V453.545C380.291 456.87 377.595 459.566 374.271 459.566H275.911C272.587 459.566 269.891 456.87 269.891 453.545V424.305ZM234.949 293.583C231.624 293.583 228.929 296.279 228.929 299.603V375.284C228.929 378.609 231.624 381.305 234.949 381.305H257.377C260.702 381.305 263.397 378.609 263.397 375.284V299.603C263.397 296.279 260.702 293.583 257.377 293.583H234.949Z",
    fill: "#CFCFCF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 522.192,
    y: 340.884,
    width: 116.102,
    height: 118.682,
    rx: 8.60011,
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.149 402.493L625.461 389.433C632.696 412.967 619.096 438.226 595.335 445.391C579.878 450.05 563.035 446.178 551.232 435.251L582.149 402.493Z",
    fill: "#B3B3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.149 402.493L551.232 435.251C545.426 429.877 541.15 423.083 538.836 415.553C531.601 392.021 545.202 366.76 568.962 359.596C576.565 357.305 584.645 357.035 592.387 358.813L582.149 402.493Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.149 402.493L592.387 358.813C600.128 360.593 607.26 364.362 613.066 369.737C618.871 375.11 623.148 381.905 625.461 389.433L582.149 402.493Z",
    fill: "#82A6C9",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 388.891,
    y: 340.884,
    width: 124.702,
    height: 118.682,
    rx: 8.60011,
    fill: "#FFA800"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.791,
    y: 410.617,
    width: 9.65656,
    height: 40.3695,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.855,
    y: 438.069,
    width: 9.65656,
    height: 12.9183,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.387,
    y: 426.765,
    width: 9.65656,
    height: 24.2217,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.653,
    y: 417.076,
    width: 9.65656,
    height: 33.9104,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.057,
    y: 384.781,
    width: 9.65656,
    height: 66.206,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.323,
    y: 371.863,
    width: 9.65656,
    height: 79.1243,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.589,
    y: 384.781,
    width: 9.65656,
    height: 66.206,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.121,
    y: 363.789,
    width: 9.65656,
    height: 87.1982,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.919,
    y: 358.944,
    width: 9.65656,
    height: 92.0425,
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 388.891,
    y: 225.643,
    width: 249.403,
    height: 103.201,
    rx: 8.60011,
    fill: "#2251FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 404.371,
    y: 240.263,
    width: 19.7803,
    height: 73.101,
    fill: "white",
    fillOpacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 454.251,
    y: 240.263,
    width: 19.7803,
    height: 73.101,
    fill: "white",
    fillOpacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 504.132,
    y: 240.263,
    width: 19.7803,
    height: 73.101,
    fill: "white",
    fillOpacity: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 554.013,
    y: 240.263,
    width: 19.7803,
    height: 73.101,
    fill: "white",
    fillOpacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 603.893,
    y: 240.263,
    width: 19.7803,
    height: 73.101,
    fill: "white",
    fillOpacity: 0.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 404.371,
    y: 283.263,
    width: 19.7803,
    height: 30.1004,
    fill: "white",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 454.251,
    y: 258.323,
    width: 19.7803,
    height: 55.0407,
    fill: "white",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 504.132,
    y: 293.583,
    width: 19.7803,
    height: 19.7803,
    fill: "white",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 554.013,
    y: 251.443,
    width: 19.7803,
    height: 61.9208,
    fill: "white",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 603.893,
    y: 297.883,
    width: 19.7803,
    height: 15.4802,
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 706.697,
    cy: 603.728,
    rx: 26.2303,
    ry: 1.72002,
    fill: "#979797",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M711.132 534.584C687.759 534.584 682.55 520.439 686.372 498.061C686.719 496.032 687.126 494.177 687.511 492.425C688.969 485.782 690.102 480.621 686.372 473.073C682.467 465.168 676.823 460.852 671.214 456.563C664.885 451.723 658.602 446.918 654.915 437.03C647.99 418.459 667.247 408.5 681.952 411.666C692.092 413.849 693.807 421.108 695.176 426.898C695.792 429.506 696.338 431.816 697.551 433.23C699.08 435.014 701.196 435.983 703.571 437.072C707.265 438.764 711.585 440.744 715.298 446.518C718.798 451.962 718.637 455.272 718.478 458.534C718.359 460.958 718.243 463.355 719.63 466.581C720.533 468.683 724.33 473.597 727.151 477.249L727.151 477.25C728.336 478.784 729.349 480.095 729.903 480.882C746.46 504.378 735.512 532.154 714.003 534.434C714.538 547.203 713.88 562.568 713.291 576.287L713.291 576.287C712.997 583.14 712.721 589.582 712.62 595.084C712.62 565.202 711.943 546.386 711.144 534.584H711.132ZM693.215 453.176C684.842 445.844 679.489 438.849 677.169 432.175C677.055 431.849 677.23 431.493 677.56 431.38C677.889 431.268 678.249 431.441 678.362 431.768C680.601 438.209 685.827 445.038 694.051 452.238C706.096 462.785 713.529 489.767 711.528 512.268C711.497 512.612 711.191 512.867 710.844 512.836C710.496 512.806 710.24 512.502 710.27 512.158C712.24 490.016 704.913 463.419 693.215 453.176Z",
    fill: "#FFA800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M691.588 499.175L691.588 499.175C690.998 495.856 690.463 492.841 689.875 490.543C687.032 479.419 678.605 467.22 668.319 466.595C659.361 466.051 657.338 481.004 660.235 489.373C662.704 496.506 664.563 499.901 668.215 506.573C668.848 507.729 669.534 508.983 670.287 510.372C673.516 516.329 674.27 520.641 674.936 524.452C675.322 526.659 675.679 528.698 676.469 530.792C679.815 539.654 683.551 542.454 686.8 544.889C688.936 546.49 690.86 547.933 692.326 550.835C695.632 557.384 700.568 558.381 704.495 557.634C706.517 563.979 709.293 575.934 711.132 597.025C711.487 577.177 710.636 567.714 706.948 556.821C710.755 554.687 714.907 547.514 711.132 538.162C708.896 532.622 706.059 530.225 703.329 527.917C700.993 525.943 698.735 524.035 696.997 520.28C694.304 514.459 692.827 506.146 691.588 499.175ZM684.351 511.358C682.509 504.403 678.064 494.546 671.016 481.808C670.849 481.505 670.96 481.125 671.266 480.959C671.572 480.793 671.955 480.904 672.123 481.207C679.216 494.027 683.698 503.965 685.572 511.041C688.124 520.681 696.485 537.366 700.179 540.978C700.427 541.221 700.43 541.617 700.185 541.863C699.94 542.109 699.541 542.111 699.293 541.869C695.414 538.076 686.956 521.197 684.351 511.358Z",
    fill: "#103559"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M731.829 463.251C731.057 463.677 730.248 464.122 729.382 464.578C726.307 466.198 721.241 470.126 717.77 476.208C714.308 482.275 712.427 490.493 715.708 500.743C719.038 511.149 719.501 516.887 718.677 521.921C718.267 524.426 717.541 526.744 716.716 529.347L716.659 529.527C715.848 532.088 714.942 534.947 714.126 538.581C712.451 546.038 712.143 552.082 713.239 556.2C713.785 558.252 714.671 559.796 715.88 560.809C716.124 561.013 716.383 561.198 716.657 561.361C717.662 546.639 719.624 532.964 723.076 524.78C727.603 525.61 724.955 527.512 724.955 527.512C724.955 527.512 721.77 541.269 719.077 562.189C719.558 562.257 720.07 562.282 720.612 562.262C722.581 562.192 723.733 561.626 724.552 560.731C725.398 559.805 725.926 558.49 726.551 556.804C726.598 556.678 726.645 556.55 726.693 556.42C727.913 553.112 729.521 548.75 734.576 544.312C744.776 535.359 746.368 524.695 746.368 516.104C746.368 511.855 745.262 508.246 744.01 504.863C743.759 504.186 743.501 503.516 743.246 502.85C742.232 500.211 741.245 497.643 740.823 495.002C739.751 488.29 743.751 481.336 749.788 477.549C752.561 475.809 753.82 471.897 753.365 468.123C752.911 464.363 750.781 460.947 747.015 460.115C743.081 459.247 740.249 459.543 737.633 460.449C735.701 461.118 733.895 462.113 731.829 463.251ZM715.329 561.467C715.72 561.795 716.142 562.075 716.594 562.307C715.789 574.622 715.642 587.6 715.841 598.659C716.457 585.592 717.647 573.456 718.968 563.042C719.499 563.116 720.059 563.143 720.645 563.122C722.789 563.044 724.181 562.413 725.188 561.311C726.166 560.241 726.744 558.761 727.358 557.104C727.404 556.98 727.45 556.854 727.497 556.727C728.708 553.444 730.254 549.252 735.145 544.959C745.609 535.774 747.229 524.815 747.229 516.106C747.229 511.704 746.08 507.98 744.816 504.567C744.556 503.864 744.293 503.177 744.033 502.501C743.024 499.872 742.079 497.412 741.673 494.869C740.667 488.576 744.426 481.929 750.247 478.277C753.404 476.297 754.697 471.985 754.219 468.023C753.739 464.047 751.449 460.214 747.198 459.276C743.116 458.375 740.123 458.676 737.349 459.637C735.343 460.332 733.444 461.378 731.353 462.53C730.592 462.949 729.806 463.382 728.98 463.817C725.779 465.504 720.584 469.539 717.022 475.781C713.451 482.039 711.528 490.505 714.888 501.003C718.199 511.345 718.621 516.935 717.828 521.78C717.43 524.215 716.723 526.475 715.896 529.086L715.837 529.272C715.026 531.832 714.111 534.72 713.286 538.391C711.601 545.891 711.258 552.098 712.407 556.418C712.984 558.585 713.944 560.307 715.329 561.467Z",
    fill: "#2251FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.043 573.706C692.093 573.706 691.323 574.476 691.323 575.426V576.989C691.323 577.939 692.093 578.709 693.043 578.709H695.109V595.128C695.109 599.877 698.96 603.728 703.709 603.728H724.372C729.122 603.728 732.972 599.877 732.972 595.128V578.709L735.038 578.709C735.988 578.709 736.758 577.939 736.758 576.989V575.426C736.758 574.476 735.988 573.706 735.038 573.706H693.043Z",
    fill: "#DFDFDF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.972 576.207H705.699L703.944 578.709H732.972V576.207Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602.358 532.643C598.206 532.357 578.895 529.189 580.255 495.046C606.269 507.93 606.004 522.879 604.343 529.376C609.89 544.619 612.996 564.724 612.582 587.927C610.173 560.222 604.962 540.944 602.358 532.643Z",
    fill: "#103559"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.88 550.704C627.032 550.417 646.342 547.249 644.983 513.107C618.969 525.99 619.234 540.94 620.894 547.436C615.348 562.679 612.242 582.784 612.656 605.988C615.065 578.282 620.276 559.004 622.88 550.704Z",
    fill: "#AEAEAE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.592 513.746C630.898 512.298 650.647 504.726 648.81 465.376C605.276 486.469 618.051 512.273 618.964 513.993C614.636 536.303 612.292 574.077 612.656 594.378C614.054 564.642 619.613 530.442 622.592 513.746Z",
    fill: "#103559"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.994 492.184C611.006 492.184 611.012 492.183 611.012 492.183C611.012 492.183 619.31 478.489 595.909 467.956C594.636 486.116 603.142 490.679 607.92 491.815C608.965 496.64 612.852 518.963 612.852 584.057C612.927 579.947 613.069 575.039 613.226 569.635C613.957 544.401 615.003 508.35 610.994 492.184Z",
    fill: "#2251FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.116,
    cy: 612.868,
    rx: 26.2303,
    ry: 1.72002,
    fill: "#979797",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.685 577.607H635.85C637.359 577.607 638.581 578.829 638.581 580.335V581.095C638.581 582.322 637.958 583.465 636.927 584.13L634.965 585.395V594.141C634.965 598.883 633.641 603.53 631.141 607.561L631.028 607.743C628.721 611.464 624.65 613.728 620.269 613.728H606.267C601.885 613.728 597.815 611.464 595.508 607.743L595.395 607.561C592.895 603.53 591.571 598.883 591.571 594.141V585.395L589.609 584.13C588.578 583.465 587.954 582.322 587.954 581.095V580.335C587.954 578.829 589.177 577.607 590.685 577.607Z",
    fill: "#DFDFDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.562 607.186H610.944L608.845 611.686H643.562V607.186Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.321 535.17C198.519 534.909 180.837 532.024 182.082 500.937C205.903 512.668 205.66 526.28 204.139 532.195C209.218 546.074 212.062 564.381 211.683 585.508C209.477 560.281 204.705 542.728 202.321 535.17Z",
    fill: "#103559"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.113 551.614C224.915 551.353 242.597 548.469 241.352 517.381C217.531 529.112 217.774 542.724 219.295 548.639C214.216 562.518 211.372 580.825 211.751 601.952C213.957 576.726 218.729 559.172 221.113 551.614Z",
    fill: "#AEAEAE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.849 517.963C228.455 516.645 246.539 509.75 244.857 473.921C204.993 493.126 216.691 516.622 217.527 518.188C213.565 538.502 211.417 572.897 211.751 591.381C213.031 564.306 218.122 533.165 220.849 517.963Z",
    fill: "#103559"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.229 498.33C210.24 498.33 210.246 498.33 210.246 498.33C210.246 498.33 217.844 485.86 196.416 476.27C195.25 492.806 203.039 496.96 207.415 497.994C208.372 502.388 211.93 522.714 211.93 581.984C211.999 578.241 212.13 573.773 212.273 568.852C212.943 545.875 213.9 513.05 210.229 498.33Z",
    fill: "#2251FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.594,
    cy: 608.217,
    rx: 24.0187,
    ry: 1.56613,
    fill: "#979797",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.633 576.111H232.99C234.371 576.111 235.491 577.223 235.491 578.595V579.287C235.491 580.404 234.92 581.444 233.975 582.05L232.179 583.202V591.166C232.179 595.483 230.967 599.715 228.677 603.385L228.574 603.551C226.461 606.939 222.734 609 218.722 609H205.901C201.889 609 198.162 606.939 196.049 603.551L195.945 603.385C193.656 599.715 192.444 595.483 192.444 591.166V583.202L190.648 582.05C189.703 581.444 189.132 580.404 189.132 579.287V578.595C189.132 577.223 190.252 576.111 191.633 576.111Z",
    fill: "#DFDFDF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.051 603.043H210.183L208.261 607.141H240.051V603.043Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.572 102.524C640.928 103.081 642.991 104.381 644.491 106.159C646.519 103.755 649.577 102.224 652.997 102.224C658.363 102.224 662.836 105.993 663.842 110.991C665.395 109.706 667.397 108.932 669.583 108.932C674.515 108.932 678.514 112.874 678.514 117.737C678.514 122.459 674.743 126.312 670.008 126.531V126.541H612.17C606.063 126.541 601.113 121.661 601.113 115.64C601.113 110.12 605.276 105.557 610.676 104.838C611.84 98.1168 617.778 93.0005 624.928 93.0005C631.232 93.0005 636.593 96.9769 638.572 102.524Z",
    fill: "url(#paint2_linear_7042_25715)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.938 244.239C709.478 245.935 710.787 247.76 712.025 249.619C713.012 251.115 713.935 252.645 714.808 254.198C716.388 253.376 718.002 252.608 719.646 251.896C721.7 251.019 723.794 250.218 726.011 249.654C724.318 251.199 722.496 252.505 720.642 253.742C719.146 254.728 717.619 255.649 716.067 256.522C716.891 258.106 717.657 259.717 718.365 261.363C719.241 263.416 720.042 265.511 720.611 267.736C719.066 266.042 717.76 264.221 716.519 262.358C715.532 260.862 714.609 259.332 713.734 257.776C712.152 258.593 710.54 259.365 708.898 260.071C706.842 260.944 704.75 261.749 702.535 262.317C704.23 260.776 706.052 259.47 707.906 258.233C709.403 257.247 710.929 256.326 712.485 255.45C711.662 253.866 710.894 252.252 710.185 250.606C709.313 248.55 708.508 246.458 707.935 244.235L707.938 244.239Z",
    fill: "#666666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.163 279.563C166.759 281.319 168.114 283.211 169.398 285.136C170.42 286.686 171.376 288.272 172.281 289.88C173.917 289.029 175.59 288.233 177.293 287.495C179.42 286.587 181.59 285.757 183.887 285.173C182.133 286.773 180.245 288.127 178.324 289.407C176.774 290.43 175.193 291.384 173.585 292.288C174.438 293.929 175.231 295.597 175.965 297.303C176.873 299.43 177.703 301.6 178.292 303.905C176.692 302.151 175.338 300.263 174.053 298.334C173.031 296.784 172.075 295.199 171.168 293.587C169.529 294.433 167.859 295.233 166.157 295.965C164.028 296.869 161.86 297.702 159.566 298.291C161.322 296.695 163.209 295.342 165.13 294.061C166.68 293.039 168.262 292.085 169.874 291.178C169.021 289.537 168.225 287.864 167.492 286.159C166.588 284.029 165.754 281.862 165.161 279.559L165.163 279.563Z",
    fill: "#051C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7042_25715",
    x1: 212.739,
    y1: 154.741,
    x2: 215.654,
    y2: 198.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7042_25715",
    x1: 548.766,
    y1: 51.8275,
    x2: 548.397,
    y2: 137.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2251FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2251FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7042_25715",
    x1: 639.813,
    y1: 93.0005,
    x2: 639.813,
    y2: 126.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopBg);
export default __webpack_public_path__ + "static/media/desktop-bg.c190eaff7ba6cab82211ab67f1c8757f.svg";
export { ForwardRef as ReactComponent };